import React, { useEffect } from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import About from "./components/About";
import WhyUS from "./components/WhyUS";
import Kinds from "./components/kinds";
import Blogs from "./components/Blogs";
import Hagz from "./components/7agz";
import Ask from "./components/Ask";
import Footer from "./components/Footer";
import FloatingIcons from "./components/FloatingIcons";

const App = () => {

  return (
    <>
      <title>مؤسسة محمد إبراهيم أبو عدبة للمحاماة والاستشارات القانونية</title>
      <Nav />
      <FloatingIcons />
      <Hero />
      <About />
      <WhyUS />
      <Kinds />
      <Blogs />
      <Hagz />
      <Ask />
      <Footer />
    </>
  );
};

export default App;
